function layoutCSS(layout) {
  const sharedStyles = `
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 9999;
  overflow:hidden;
  border-style: solid;`;

  switch (layout) {
    case 'ON_SITE_CLASSIC':
      return `${sharedStyles}
  bottom: 0;
  width: 400px;
  min-height: 300px;
  gap: 16px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-top-width: 2px;
  border-left-width: 2px;
  border-right-width: 2px;
  left: 24px;
  right:auto;`;
    case 'ON_SITE_MODAL':
      return `${sharedStyles}
  inset: 0;
  margin: auto;
  width: 40%;
  height: fit-content;
  flex: 1;
  border-radius: 8px;
  border-width: 2px;`;
    case 'MOBILE_MODAL':
      return `${sharedStyles}
  inset: 0;
  margin: auto;
  width: calc(100% - 32px);
  height: calc(100% - 32px);
  border-radius: 8px;
  border-width: 2px;`;
    default:
      return '';
  }
}

function buildCSSTemplate(layout) {
  const css = `

.survey-layout {
  ${layoutCSS(layout)}
}
.survey-wrapper {
  padding:24px;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.survey-text {
  font-family:inherit;
  font-size:inherit;
  color:inherit;
}

.survey-body {
  display: flex;
  flex: 1;
  max-height: fit-content;
  flex-direction: column;
  gap: 8px;
}

.survey-action {
  margin-top: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  max-height: fit-content;
  justify-content: space-between;
  font-family:inherit;
  font-size:inherit;
}

.survey-action-btn {
  border: none;
  outline: none;
  padding: 4px 24px;
  cursor: pointer;
  border-radius: 2px;
  font-size: inherit;
  font-family:inherit;
  }`;

  return css.replace(/(^[ \t]*\n)/gm, '');
}

export { buildCSSTemplate };
